import "./Menu.css";
import { IconButton, List, ListItem, ListItemText, } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { ApiNavigation, ApiNavigationType } from "enum/api";
import { IMenuItem } from "./MenuProps";
import { FnAxios } from "utilities/utilities";
import MenuItems from "./MenuItem";
import MenuItemCollapse from "./MenuItemCollapse";
import { ProviderLayout } from "view/ExampleLayout/Admin";
import MenuOpenRoundedIcon from '@mui/icons-material/MenuOpenRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';

const MenuBar = () => {
    const AxiosFn = FnAxios();

    const {
        IsMenuOpen,
        setIsMenuOpen,
        IsOverMouse,
        setIsOverMouse,
        isMouseOver
    } = useContext(ProviderLayout);

    const [arrData, setMenu] = useState<IMenuItem[]>([]);

    useEffect(() => {
        let result: IMenuItem[] = [];
        AxiosFn.Get(ApiNavigation.GetMenu, { nMenuType: ApiNavigationType.BackEnd }, (d) => {
            result = d.objResult.lstMenu;
            setMenu([...result]);
        })
    }, []);

    const handleDrawerClose = () => {
        setIsMenuOpen(!IsMenuOpen);
    }

    const HandleOverMenu = () => {
        if (!IsMenuOpen && isMouseOver) {
            setIsMenuOpen(true)
            setIsOverMouse(true)
        }
    }

    const HandleLeaveMenu = () => {
        if (IsOverMouse && isMouseOver) {
            setIsMenuOpen(false)
            setIsOverMouse(false)
        }
    }

    const {
        Layout630,
    } = useContext(ProviderLayout);

    return (
        <List
            component="nav"
            className="nav-menu"
            subheader={
                <ListItem className="nav-menu-burger" style={{ justifyContent: 'center', display: Layout630 ? "" : "none" }}>
                    {IsMenuOpen ? <ListItemText primary={"Menu"} className="icon-menu" /> : null}
                    <IconButton onClick={handleDrawerClose}>
                        {IsMenuOpen ? <MenuOpenRoundedIcon className="icon-menu" /> : <MenuRoundedIcon className="icon-menu" />}
                    </IconButton>
                </ListItem>
            }
        >
            {/* <Divider /> */}
            <div
                onMouseOver={HandleOverMenu}
                onMouseLeave={HandleLeaveMenu}
            >
                {
                    arrData.map((item) => {
                        let sMenuID = "menu-" + item.nMenuID;
                        return (item.lstChildrenMenu.length > 0 ?
                            <MenuItemCollapse key={sMenuID} {...item} />
                            :
                            <MenuItems key={sMenuID} {...item}></MenuItems>)
                    })
                }
            </div>
        </List>
    )
}
export default MenuBar;
